import { createFileRoute } from '@tanstack/react-router';
import { PageShell, Section } from '~/components/layout';
import { Icon } from '~/components/ui';
import { businessSuccess } from '~/content/businessSuccess';

export const Route = createFileRoute('/products/business-success')({
  // A post-submission confirmation screen has no standalone search value and
  // should never be indexed, so it skips `pageHeadMeta` (canonical + OG + JSON-LD)
  // the way the other utility routes do.
  head: () => ({
    meta: [
      { title: 'Application submitted — nsave Business' },
      { name: 'robots', content: 'noindex' },
    ],
  }),
  component: BusinessSuccessPage,
});

function BusinessSuccessPage() {
  return (
    <PageShell>
      <Section className="py-20 md:py-32">
        <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
          <span className="flex size-14 shrink-0 items-center justify-center rounded-full bg-red-500 text-white">
            <Icon name="check" tint className="size-7" />
          </span>

          <h1 className="mt-8 text-[32px] leading-[1.1] font-semibold tracking-[-0.03em] text-balance md:text-h2">
            {businessSuccess.title}
          </h1>

          <p className="mt-6 text-body text-grey-900 md:text-[20px] md:leading-[1.4]">
            {businessSuccess.body}
          </p>

          <hr className="mt-12 w-full max-w-md border-t border-black-6" />

          <p className="mt-8 text-body md:text-[20px]">
            <span className="font-semibold">{businessSuccess.help.label}</span>{' '}
            <a
              href={`mailto:${businessSuccess.help.email}`}
              className="hover:text-red-500 hover:underline hover:underline-offset-4">
              {businessSuccess.help.email}
            </a>
          </p>
        </div>
      </Section>
    </PageShell>
  );
}
